import React from "react"
import Home from "../base-pages/index"

const HomeEN = () => {
  return <Home lang="en" />
}

export default HomeEN
